export default "__VITE_ASSET__BDkqtd8X__"